import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UploadZone = ({ onFileSelect, isDragging, onDragOver, onDragLeave, onDrop }) => {
  const handleFileInputChange = (event) => {
    const files = Array.from(event?.target?.files);
    onFileSelect(files);
  };

  return (
    <div
      className={`border-2 border-dashed rounded-lg p-8 lg:p-12 text-center transition-all duration-200 ${
        isDragging
          ? 'border-primary bg-primary/5 scale-[1.02]'
          : 'border-border hover:border-primary/50 hover:bg-muted/30'
      }`}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <div className="flex flex-col items-center gap-4">
        <div className={`w-16 h-16 rounded-full flex items-center justify-center transition-colors duration-200 ${
          isDragging ? 'bg-primary/20' : 'bg-muted'
        }`}>
          <Icon 
            name="Upload" 
            size={32} 
            color={isDragging ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
          />
        </div>
        
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {isDragging ? 'Drop files here' : 'Upload Files to S3'}
          </h3>
          <p className="text-sm text-muted-foreground mb-1">
            Drag and drop files here, or click to browse
          </p>
          <p className="text-xs text-muted-foreground font-mono">
            Supported: Images, Videos, Documents, Archives (Max 100MB per file)
          </p>
        </div>

        <input
          type="file"
          multiple
          onChange={handleFileInputChange}
          className="hidden"
          id="file-upload-input"
          accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar"
        />
        <label htmlFor="file-upload-input">
          <Button variant="default" iconName="FolderOpen" iconPosition="left" asChild>
            <span>Browse Files</span>
          </Button>
        </label>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Icon name="Image" size={14} />
            <span>Images</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Icon name="Video" size={14} />
            <span>Videos</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Icon name="FileText" size={14} />
            <span>Documents</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Icon name="Archive" size={14} />
            <span>Archives</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadZone;